(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/fraction-payment.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/fraction-payment.js');
"use strict";

var _svs;

const {
  form,
  format
} = svs.utils;
const {
  urlMapping
} = svs.core;
const {
  BottomSheetIntersersect
} = svs.components.lbUi.bottomSheetIntersect;
const {
  selectors
} = svs.components.marketplaceData;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const {
  useHistory
} = ReactRouterDOM;
const {
  breakpoints,
  useMediaQuery,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  PayButton
} = svs.components.marketplace.fractionPayment;
const {
  useEffect,
  useState,
  useRef
} = React;
const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  QS_FRACTION_DATA
} = svs.components.marketplaceShared.sharedConstants.constants;
const termsUrl = "/dokument/".concat((_svs = svs) === null || _svs === void 0 || (_svs = _svs.marketplace) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.marketplaceDocumentId) === null || _svs === void 0 ? void 0 : _svs.documentId);

const FractionPayment = _ref => {
  let {
    activatedDrawId,
    block,
    className,
    fractionPurchaseLoading,
    groupId,
    hasSnackbar,
    isSmall,
    isBrowseGames
  } = _ref;
  const dispatch = useDispatch();
  const history = useHistory();
  const group = useSelector(state => selectors.teams.selectTeam(state, {
    id: groupId
  }));
  const isRetail = group.type === 'RETAILER' || isBrowseGames;
  const hasJoinTeam = group.type === 'RETAILER' && !group.isFollowing;
  const invitationToken = group.token;
  let currentMaxFractions;
  const getDiffDateFromNow = date => date.getTime() - Date.now();
  const isSmallDevice = useMediaQuery(breakpoints.down(BREAKPOINT_AM));
  const memberId = useSelector(state => state.customerId);
  const returnUrlQuery = "".concat(QS_FRACTION_DATA, "=").concat(activatedDrawId, "_").concat(groupId);
  const searchParams = new URLSearchParams(location.search);
  const {
    fractionPrice,
    maxFractionsPerMember,
    maxFractions,
    buyStop,
    isSubmitted,
    isSoldOut 
  } = useSelector(state => selectors.games.getGame(state, {
    activatedDrawId,
    groupId
  }) || isRetail && selectors.games.getBrowseGame(state, {
    activatedDrawId,
    groupId
  })) || {};
  const isCurrentUserAuthenticated = Boolean(useSelector(state => state.customerId));
  const currentPurchasedFractions = useSelector(state => selectors.games.getPurchasedFractionsForMember(state, {
    activatedDrawId,
    groupId,
    memberId
  }));
  const returnUrl = !isCurrentUserAuthenticated ? "".concat(window.location.pathname, "?").concat(returnUrlQuery) : null;
  const marketplaceFractionData = searchParams.get(QS_FRACTION_DATA);
  const params = (marketplaceFractionData === null || marketplaceFractionData === void 0 ? void 0 : marketplaceFractionData.split('_')) || [];
  const [isBeforeBuyStop, setIsBeforeBuyStop] = useState(buyStop && getDiffDateFromNow(buyStop) > 0);
  const [buyStopState, setBuystopState] = useState(buyStop);
  const [disabledBuyButton, setDisabledBuyButton] = useState(false);
  const fractionPaymentInProgress = useRef(false);
  const timeoutToBuyStop = useRef();
  useEffect(() => {
    const queryActivatedDrawId = params[0];
    const queryGroupId = params[1];
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete(QS_FRACTION_DATA);
    if (isCurrentUserAuthenticated && queryActivatedDrawId && queryGroupId) {
      if (parseInt(queryActivatedDrawId, 10) === activatedDrawId && parseInt(queryGroupId, 10) === groupId) {
        if (history.location.state) {
          history.location.state.hasBackButton = true;
        } else {
          history.location.state = {
            hasBackButton: true
          };
        }
        history.replace({
          search: queryParams.toString()
        });
        svs.components.marketplace.fractionPayment.showPaymentDialog(dispatch, setDisabledBuyButton, fractionPrice, termsUrl, groupId, activatedDrawId, isRetail, hasJoinTeam, invitationToken);
      }
    }
  }, [activatedDrawId, groupId]);
  const hasReachedMaxFractionsPerMember = () => {
    if (!group.type) {
      return undefined;
    }
    let calcHasReachedMaxFractionsPerMember;
    switch (group.type) {
      case 'RETAILER':
        currentMaxFractions = maxFractions;
        calcHasReachedMaxFractionsPerMember = maxFractions - currentPurchasedFractions < 1;
        break;
      case 'PRIVATE':
        currentMaxFractions = maxFractionsPerMember;
        calcHasReachedMaxFractionsPerMember = maxFractionsPerMember - currentPurchasedFractions < 1;
        break;
      default:
        throw new Error('unknown group type');
    }
    return calcHasReachedMaxFractionsPerMember;
  };
  const handleNavigateToTransfer = () => {
    form.postToUrl(svs.core.urlMapping.get('transactionsHome'), {
      returnUrl: window.location.href
    });
  };
  const handleCheckAccountBalance = callback => {
    svs.components.marketplaceData.fractionPayment.services.fetchAccountBalance((error, balance) => callback(error, balance));
  };
  const handleShowTransferDialog = (_ref2, callback) => {
    let {
      balance,
      fractionPrice,
      message
    } = _ref2;
    const msg = message || 'Du har inte tillräckligt med pengar på ditt spelkonto.';
    const text = "<p>Ditt saldo: ".concat(format.Currency(balance), " kr<br />Andelspris: ").concat(format.Currency(fractionPrice), " kr</p>");
    const buttons = [{
      text: 'Avbryt',
      classes: {
        inverted: true
      }
    }, {
      text: 'Sätt in',
      classes: {
        focus: true
      },
      callback
    }];
    dispatch(showDialog({
      title: msg,
      text,
      buttons,
      icon: 'balance'
    }));
  };
  const cantBuy = hasReachedMaxFractionsPerMember() || isSoldOut || !isBeforeBuyStop || fractionPurchaseLoading || Boolean(isSubmitted) || disabledBuyButton;
  const getCantBuyReason = () => {
    if (hasReachedMaxFractionsPerMember()) {
      const shouldDisplay = isBeforeBuyStop && !isSoldOut && !fractionPurchaseLoading && !isSubmitted;
      return shouldDisplay ? "Max ".concat(currentMaxFractions, " andelar") : null;
    }
    return null;
  };
  const handleCheckPlayerTimelimits = async cb => {
    const timeLimitData = await svs.accountServices.player_timelimits.getPlayerTimeLimits();
    if (timeLimitData && (timeLimitData.day.remaining === '0' || timeLimitData.week.remaining === '0' || timeLimitData.month.remaining === '0')) {
      cb(true);
      return;
    }
    cb(false);
  };
  const handleOnPayButtonClick = async () => {
    setDisabledBuyButton(true);
    if (!isCurrentUserAuthenticated) {
      window.location = "".concat(urlMapping.get('loginHome'), "?returnUrl=").concat(returnUrl);
      return;
    }
    const canPlay = await svs.accountservices.player_exclusions.canPlayOnVertical('sport');
    if (!canPlay) {
      return;
    }
    const handlePayment = () => {
      if (fractionPaymentInProgress.current) {
        return;
      }
      fractionPaymentInProgress.current = true;
      handleCheckPlayerTimelimits(hasReachedLimit => {
        fractionPaymentInProgress.current = false;
        if (hasReachedLimit) {
          const {
            title,
            text,
            buttons,
            icon
          } = svs.components.marketplaceShared.specificDialogs.dialogs.timelimitDialog;
          dispatch(showDialog({
            title,
            text,
            buttons,
            icon
          }));
        } else {
          handleCheckAccountBalance((error, balance) => {
            if (error) {
              dispatch(showDialog({
                title: 'Det gick inte att hämta saldot.',
                type: 'error'
              }));
              return;
            }
            if (balance < fractionPrice) {
              return handleShowTransferDialog({
                balance,
                fractionPrice,
                message: 'Du har inte tillräckligt med pengar på ditt spelkonto för att köpa en andel.'
              }, handleNavigateToTransfer);
            }
            svs.components.marketplace.fractionPayment.showPaymentDialog(dispatch, setDisabledBuyButton, fractionPrice, termsUrl, groupId, activatedDrawId, isRetail, hasJoinTeam, invitationToken);
          });
        }
      });
    };
    handlePayment();
  };
  const timeOutForBuyStop = () => {
    setIsBeforeBuyStop(false);
  };
  useEffect(() => {
    if (buyStop !== buyStopState && buyStop > new Date()) {
      setIsBeforeBuyStop(true);
      setBuystopState(buyStop);
    }
  }, [buyStop, buyStopState]);
  useEffect(() => {
    if (buyStop && getDiffDateFromNow(buyStop) > 0) {
      if (!timeoutToBuyStop.current) {
        timeoutToBuyStop.current = setTimeout(timeOutForBuyStop, getDiffDateFromNow(buyStop));
      }
    }
    return () => {
      if (timeoutToBuyStop.current) {
        clearTimeout(timeoutToBuyStop.current);
      }
    };
  }, [buyStop]);
  if (!hasSnackbar) {
    return React.createElement("div", {
      className: className
    }, React.createElement(PayButton, {
      block: block,
      cantBuy: cantBuy,
      cantBuyReason: cantBuy ? getCantBuyReason() : null,
      fractionPrice: fractionPrice,
      fractionPurchaseLoading: fractionPurchaseLoading,
      isSmall: isSmall,
      onClick: handleOnPayButtonClick
    }));
  }
  return React.createElement("div", {
    className: className
  }, isSmallDevice && !hasReachedMaxFractionsPerMember() && !isSoldOut && React.createElement("div", {
    className: "snackbar-container"
  }, React.createElement(BottomSheetIntersersect, {
    intersectId: "snackbar-selector"
  }, React.createElement("div", {
    className: "margin-top-1 margin-bottom-1 margin-right margin-left"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    cantBuyReason: cantBuy ? getCantBuyReason() : null,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: fractionPurchaseLoading,
    isCurrentUserAuthenticated: isCurrentUserAuthenticated,
    isSmall: isSmall,
    onClick: handleOnPayButtonClick
  })))), React.createElement("div", {
    className: className,
    "data-testid": "qa-fraction-snackbar",
    id: "snackbar-selector"
  }, React.createElement(PayButton, {
    block: block,
    cantBuy: cantBuy,
    cantBuyReason: cantBuy ? getCantBuyReason() : null,
    fractionPrice: fractionPrice,
    fractionPurchaseLoading: fractionPurchaseLoading,
    isCurrentUserAuthenticated: isCurrentUserAuthenticated,
    isSmall: isSmall,
    onClick: handleOnPayButtonClick
  })));
};
FractionPayment.defaultProps = {
  className: '',
  hasSnackbar: false,
  isSmall: false
};

setGlobal('svs.components.marketplace.fractionPayment.FractionPayment', FractionPayment);

 })(window);